import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step-progress-tracker mb-4" }
const _hoisted_2 = { class: "progress-container" }
const _hoisted_3 = { class: "progress-bar-bg" }
const _hoisted_4 = { class: "steps-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "step-circle" }
const _hoisted_7 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_8 = {
  key: 1,
  class: "fas fa-edit"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "step-content" }
const _hoisted_11 = { class: "step-title" }
const _hoisted_12 = { class: "step-subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "step-timestamp"
}
const _hoisted_14 = { class: "progress-summary mt-3" }
const _hoisted_15 = { class: "row g-3" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = { class: "summary-card" }
const _hoisted_18 = { class: "summary-content" }
const _hoisted_19 = { class: "summary-value" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "summary-card" }
const _hoisted_22 = { class: "summary-content" }
const _hoisted_23 = { class: "summary-value" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = { class: "summary-card" }
const _hoisted_26 = { class: "summary-content" }
const _hoisted_27 = { class: "summary-value" }
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "summary-card" }
const _hoisted_30 = { class: "summary-content" }
const _hoisted_31 = { class: "summary-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "progress-bar-fill",
          style: _normalizeStyle({ width: _ctx.progressPercentage + '%' })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: step.key,
            class: _normalizeClass(["step-item", {
            'completed': step.completed,
            'current': step.current,
            'accessible': step.accessible,
            'locked': !step.accessible
          }]),
            onClick: ($event: any) => (_ctx.navigateToStep(step))
          }, [
            _createElementVNode("div", _hoisted_6, [
              (step.completed)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : (step.current)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(index + 1), 1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(step.title), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(step.subtitle), 1),
              (step.completedAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(step.completedAt)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "summary-icon" }, [
              _createElementVNode("i", { class: "fas fa-tasks text-primary" })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.completedSteps) + "/" + _toDisplayString(_ctx.totalSteps), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "summary-label" }, "Étapes complétées", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "summary-icon" }, [
              _createElementVNode("i", { class: "fas fa-percentage text-success" })
            ], -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.progressPercentage) + "%", 1),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "summary-label" }, "Progression", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "summary-icon" }, [
              _createElementVNode("i", { class: "fas fa-arrow-right text-info" })
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.nextStepTitle || 'Terminé'), 1),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "summary-label" }, "Prochaine étape", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "summary-icon" }, [
              _createElementVNode("i", { class: "fas fa-save text-warning" })
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.canSaveDraft ? 'Oui' : 'Non'), 1),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "summary-label" }, "Sauvegarde possible", -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}